<div class="thp-form-container">
  <div class="thp-message">
    <h1 class="thp-header">{{ "talent-happy-path.initial-interview-questions.hang-tight-page.header" | translate }}</h1>
    <div class="spinner-container">
      <mat-spinner [diameter]="40"></mat-spinner>
    </div>
  </div>
  <div class="button-container">
    <button mat-button class="later-button" (click)="clickIllDoThisLater()"> {{ "talent-happy-path.buttons.do-later" | translate }} </button>
  </div>
</div>
